import { useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { decrypt, encrypt } from './utils';

import { JotaiStore } from '@/states/store';

export const AccessTokenStorageKey = '@AccessStorage';

export const AccessTokenAtom = atomWithStorage<string | null>(
  AccessTokenStorageKey,
  null,
  {
    getItem: (key: string) => {
      try {
        const encryptedItem = localStorage.getItem(key);
        if (!encryptedItem) {
          return null;
        }
        return decrypt(encryptedItem);
      } catch {
        return null;
      }
    },
    setItem: (key: string, value: string | null) => {
      try {
        if (value === null) {
          localStorage.removeItem(key);
          return;
        }
        const encryptedValue = encrypt(value);
        localStorage.setItem(key, encryptedValue);
      } catch {
        // Handle error silently
      }
    },
    removeItem: (key: string) => {
      try {
        localStorage.removeItem(key);
      } catch {
        // Handle error silently
      }
    },
  },
  {
    getOnInit: true,
  }
);

export const getAccessToken = () => {
  return JotaiStore.get(AccessTokenAtom);
};

export const useSetAccessToken = () => {
  return useSetAtom(AccessTokenAtom);
};
